// decode html entities using the built-in DOMParser API.
const decodeHtml = (html) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

export { decodeHtml };
